/* 3DMA product page v2. No libraries. Safe to load more than once.
   13 Oct 2026 fix: re-runs when the collection "Choose options" pop-up loads a product
   (before, only the first pop-up got the licence cards wired up; later ones showed the old pills too). */
(function () {
  if (typeof window.__dmaProductInit === 'function') { window.__dmaProductInit(); return; }

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function productRoot(el) {
    return (el && el.closest('product-info')) || document.querySelector('product-info[id^="MainProduct"]') || document;
  }

  function checkedValue(root) {
    var r = root.querySelector('variant-selects input[type="radio"]:checked');
    if (r) return r.value;
    var s = root.querySelector('variant-selects select');
    return s ? s.value : null;
  }

  function onVariantChange(root, cb) {
    root.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(cb, 0);
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(cb, 0); });
    }
  }

  /* ---------- Licence cards (#8) ---------- */
  function initLicence(box) {
    if (box.dataset.dmaInit) return;
    box.dataset.dmaInit = '1';
    var root = productRoot(box);
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-dma-value]'));
    var radios = function () { return Array.prototype.slice.call(root.querySelectorAll('variant-selects input[type="radio"]')); };
    if (!radios().length || !cards.length) return; // no pills to drive: leave the page as it was

    function sync() {
      var v = checkedValue(root);
      cards.forEach(function (c) {
        var on = c.getAttribute('data-dma-value') === v;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      box.querySelectorAll('[data-dma-for]').forEach(function (p) {
        p.hidden = p.getAttribute('data-dma-for') !== v;
      });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var v = c.getAttribute('data-dma-value');
        var r = radios().filter(function (x) { return x.value === v; })[0];
        if (r && !r.checked) {
          r.click(); // Dawn handles the change exactly as if the pill was tapped
          track('dma_licence_card_selected', { licence: v });
        }
        sync();
      });
    });
    onVariantChange(root, sync);
    sync();
    root.classList.add('dma-lic-ready'); // hides the old pills (still in the page for Dawn/apps)
  }

  /* ---------- Mobile sticky Add to cart (#10a) ---------- */
  function initSticky(bar) {
    if (bar.dataset.dmaInit) return;
    bar.dataset.dmaInit = '1';
    if (bar.closest('quick-add-modal')) return; // product pages only: never in the collection pop-up
    var root = productRoot(bar);
    var main = root.querySelector('.product-form__submit[name="add"]');
    if (!main || !('IntersectionObserver' in window)) return;
    var prices = {};
    try { prices = JSON.parse(bar.getAttribute('data-prices') || '{}'); } catch (e) {}
    var label = bar.querySelector('[data-dma-sticky-variant]');
    var price = bar.querySelector('[data-dma-sticky-price]');
    var btn = bar.querySelector('.dma-sticky__btn');
    document.body.appendChild(bar); // escape the info column's transform so position:fixed works
    bar.hidden = false;

    var mq = window.matchMedia('(max-width: 749px)');
    var mainVisible = true;

    function current() { return root.querySelector('.product-form__submit[name="add"]') || main; }
    function update() {
      var v = checkedValue(root);
      if (v && label) label.textContent = v + ' licence · ';
      if (v && price && prices[v]) price.textContent = prices[v];
      var m = current();
      btn.disabled = !!(m && m.disabled);
    }
    function show() {
      var on = mq.matches && !mainVisible;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('dma-sticky-on', mq.matches);
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
      show();
    }).observe(main.closest('.product-form__buttons') || main);
    new MutationObserver(update).observe(main, { attributes: true, attributeFilter: ['disabled'] });
    if (mq.addEventListener) mq.addEventListener('change', show);
    onVariantChange(root, update);

    btn.addEventListener('click', function () {
      var m = current();
      if (!m || m.disabled) return;
      track('dma_sticky_atc_click', { licence: checkedValue(root) });
      m.click();
    });
    update();
    show();
  }

  /* ---------- Send to PC (#10b) ---------- */
  function initSendPc(box) {
    if (box.dataset.dmaInit) return;
    box.dataset.dmaInit = '1';
    var d = box.dataset;
    var form = box.querySelector('form');
    var msg = box.querySelector('.dma-pc__msg');
    var submit = form.querySelector('button[type="submit"]');
    var root = productRoot(box);
    var api = 'https://a.klaviyo.com/client/';
    var headers = { 'Content-Type': 'application/json', accept: 'application/json', revision: '2024-10-15' };

    function say(text, isError) {
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
    }
    function link() {
      return d.productUrl + (d.productUrl.indexOf('?') > -1 ? '&' : '?') + 'utm_source=klaviyo&utm_medium=email&utm_campaign=send-to-pc';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say('Please enter a valid email address.', true); form.email.focus(); return; }
      submit.disabled = true;
      var licence = checkedValue(root) || '';
      var event = {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Sent Product to PC' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: {
              ProductName: d.productTitle,
              ProductURL: link(),
              ImageURL: d.productImage,
              Price: parseFloat(d.productPrice) || null,
              Handle: d.productHandle,
              Licence: licence,
              Source: 'Product page (mobile)'
            }
          }
        }
      };
      var calls = [fetch(api + 'events?company_id=' + encodeURIComponent(d.klaviyoKey), { method: 'POST', headers: headers, body: JSON.stringify(event) })];
      if (form.optin && form.optin.checked && d.klaviyoList) {
        var sub = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Send to PC (product page)',
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: d.klaviyoList } } }
          }
        };
        calls.push(fetch(api + 'subscriptions?company_id=' + encodeURIComponent(d.klaviyoKey), { method: 'POST', headers: headers, body: JSON.stringify(sub) }));
      }
      Promise.all(calls).then(function (res) {
        if (!res[0].ok) throw new Error('klaviyo ' + res[0].status);
        say('Done. We’ll email the link to ' + email + ' in a minute or two.');
        form.email.value = '';
        track('dma_send_to_pc', { handle: d.productHandle, optin: !!(form.optin && form.optin.checked) });
      }).catch(function () {
        say('Sorry, that didn’t work. Use “share / copy the link” below instead.', true);
      }).then(function () { submit.disabled = false; });
    });

    var share = box.querySelector('[data-dma-share]');
    if (share) share.addEventListener('click', function () {
      var url = d.productUrl;
      track('dma_share_link', { handle: d.productHandle });
      if (navigator.share) {
        navigator.share({ title: d.productTitle, text: d.productTitle + ' (3DMilitaryAssets)', url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { say('Link copied. Paste it into an email or chat to yourself.'); }, function () { window.prompt('Copy this link:', url); });
      } else {
        window.prompt('Copy this link:', url);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-dma-licence]').forEach(initLicence);
    document.querySelectorAll('[data-dma-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-dma-sendpc]').forEach(initSendPc);
  }
  window.__dmaProductInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Backup: wire up any product block added to the page later (pop-ups, app re-renders). */
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; init(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
